module.exports = __webpack_public_path__ + "static/img/14000123.f6e1a436.png";